import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './add-teacher.styles.js'
import Button from 'pobble-components/dist/button'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import { Formik } from 'formik'
import * as Yup from 'yup'
import uuid from 'uuid'

const AddTeacher = ({ classes, schoolId, onSubmit }) => {
  const [pending, setPending] = useState(false)

  function sending(s) {
    setPending(s)
  }
  return (
    <Formik
      initialValues={{
        email: '',
        id: uuid()
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email('This field should be a valid email')
          .required('The field should not be empty')
      })}
      onSubmit={({ id, email }) => {
        sending(true)
        onSubmit(schoolId, { id, email }).then(() => sending(false))
      }}>
      {props => {
        const {
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched
        } = props
        return (
          <form onSubmit={handleSubmit} className={classes.form}>
            <FormInput type="hidden" name="id" title="id" value={values.id} />
            <div className={classes.container}>
              <FormInput
                validationError={touched.email && errors.email}
                name="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                className={classes.field}
                placeholder={'Email address'}
                required
              />
              <div className={classes.btn}>
                <Button type="submit" tall disabled={pending}>
                  {pending ? 'Sending...' : 'Invite a teacher'}
                </Button>
              </div>
            </div>
          </form>
        )
      }}
    </Formik>
  )
}

export default injectSheet(styles)(AddTeacher)
